export default __webpack_public_path__ + "static/media/image-1756184656179.01ed03c9.png";